import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Library from './Library';
import ElementBuilder from './ElementBuilder';

const ContentLibraryRoot = props => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={[
            '/content/library/elements/:elementId',
            '/content/library/elements/:elementId/edit',
          ]}
          exact
          component={ElementBuilder}
        />
        <Route path="/content/library" component={Library} />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <ContentLibraryRoot {...props} />;
